import React from "react";
import './Error.css'

const Error = () => {
  return (
    <section className="error__page">
      <h2>404</h2>
      <p>page not found</p>
    </section>
  );
};

export default Error;
